export default {
  // 标题
  title: '为华检测',

  // logo
  logo: '/dc/static/img/logo.png',

  // api

  api: {
    DICT: '/dict/config',
    FINANCE_STATISTICS: '/finance/statistics',
    REGISTER: '/passport/register',
    SEND_VERIFY: '/passport/verify',
    ORDER_LIST: '/order/myIndex',
    ORDER_INFO: '/order/info',
    ORDER_DETAILS: '/order/details',
    ORDER_CREATE: '/order/create',
    COMPANY_ALL: '/customer/all',
    STANDARD_ALL: '/standard/all',
    USER_INFO: '/user/info',
    REPORT_CHECK: '/report/check',
    REPORT_CHECK2: '/report/verify'
  },

  version:'1.2.4'

/*
  /!**
   * @type {boolean} true | false
   * @description 是否显示侧边栏
   *!/
  showSettings: true,

  /!**
   * @type {boolean} true | FALSE
   * @description 是否显示快捷导航栏
   *!/
  tagsView: true,

  /!**
   * @type {boolean} true | false
   * @description 是否固定头部
   *!/
  fixedHeader: true,

  /!**
   * @type {boolean} true | false
   * @description 是否在侧边栏中显示logo
   *!/
  sidebarLogo: true*/
}
